<template>
    <h2 class="ml-4"> Equipos </h2>
    <AdminView/>
    <h2 class="ml-4"> Usuarios </h2>
    <AdminUser/>
</template>

<script setup lang="ts">
import AdminView from '@/views/SmartLink/Admin/AdminView.vue';
import AdminUser from '@/components/RAOS/Management/AdminUser.vue';
</script>

<style scoped>

</style>